export const RESET_STATE = 'RESET_STATE';
export const SET_ACTIVE = 'SET_ACTIVE';

export const REQUEST_LOADING = 'STATISTICS_REQUEST_LOADING';
export const REQUEST_SUCCESS = 'STATISTICS_REQUEST_SUCCESS';
export const REQUEST_SUCCESS_REVIEWS = 'REQUEST_SUCCESS_REVIEWS';
export const REQUEST_FAILED = 'STATISTICS_REQUEST_FAILED';
export const UPDATE_CURRENCY = 'STATISTICS_UPDATE_CURRENCY';